import script from "./CartDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./CartDrawer.vue?vue&type=style&index=0&id=025e2374&lang=scss"

const __exports__ = script;

export default __exports__